<app-input-label [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText"></app-input-label>

<div class="input-container">
  <input
    [id]="id"
    [name]="name"
    class="input"
    [class.invalid]="isInvalid"
    type="text"
    autocomplete="off"
    [placeholder]="placeholder || ''"
    [maxlength]="maxLength"
    [disabled]="isLoading || isDisabled"
    [mask]="inputMask || ''"
    [(ngModel)]="value"
    (blur)="onTouched($event)"
    (input)="handleInput()"
  >

  <div *ngIf="isLoading" class="icon">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="possibleValues && possibleValues.length" class="list">
    <ng-container *ngFor="let item of possibleValues">
      <div class="list-item" (click)="handleListItemClick(item)">
        <span>{{ item }}</span>
      </div>
    </ng-container>
  </div>
</div>
